
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import TcclTopup from "../components/tccltopup";
import Footer from "../components/footer";

function TcclTopupPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <TcclTopup /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default TcclTopupPage;
